import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../lib/api";

export default function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [contact, setContact] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPost(null);
    setMissing(false);
    api.get(`/public/blog/${id}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
    api.get("/public/home").then((r) => setContact(r.data.contact)).catch(() => {});
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="blog-post-page">
      <Navbar />
      <div className="bg-navy py-14">
        <div className="mx-auto max-w-3xl px-6">
          <Link to="/p/news" data-testid="blog-back"
                className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-300 transition-colors hover:text-saffron">
            <ArrowLeft className="h-3.5 w-3.5" /> News & Knowledge Center
          </Link>
          {post?.category && <p className="mt-4 text-[11px] font-bold uppercase tracking-wider text-saffron">{post.category}</p>}
          <h1 className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="blog-post-title">
            {missing ? "Article Not Found" : post ? post.title : "Loading…"}
          </h1>
          {post && <p className="mt-3 text-xs text-slate-400">{(post.created_at || "").slice(0, 10)} · INDIAFAST Global Couriers</p>}
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          {post?.image_url && <img src={post.image_url} alt="" className="mb-6 w-full rounded-xl object-cover" data-testid="blog-post-image" />}
          <p className="whitespace-pre-line text-sm leading-7 text-slate-700" data-testid="blog-post-body">
            {missing ? "This article is not available." : post ? post.body : "Loading…"}
          </p>
        </div>
      </div>
      <Footer contact={contact} />
    </div>
  );
}
